import React from 'react';
import { rovLabelScoreToConditionScore } from '../../../../../common/src/domain/customInspectionTypes/inspectionLabel/rovLabel/rovLabelScoreToConditionScore';
import { LeftTrayItem, ScrollMenuItem } from '../../../components/elements';
import { ISurvey } from '../../../components/Surveys/Interfaces/ISurvey';
import { ISurveyTemplateElementGroupData } from '../../../components/Surveys/ISurveyTemplateElementGroupData';
import { ISurveyTemplateManifestationData } from '../../../components/Surveys/ISurveyTemplateManifestationData';
import { ISurveyTemplateUnitData } from '../../../components/Surveys/ISurveyTemplateUnitData';
import { useTranslate } from '../../../mixins/translate/translate';
import { ICustomInspectionTypeFrontEndSettings } from '../../ICustomInspectionTypeFrontEndSettings';
import { labelSelectOptions } from '../common/labelSelectOptions';
import { RovLabelScoreLabel } from './RovLabelScoreLabel';
import { SurveyDetailsRovLabel } from './SurveyDetailsRovLabel';
import { SurveyEditRovLabelResult } from './SurveyEditRovLabelResult';

const tabNames = {
    rovLabelResult: 'rovLabelResult',
    download: 'download',
    summaryAndAdvice: 'summaryAndAdvice',
};

function SurveyEditPage(
    props: { tabName: string; surveyId: string; objectId: string; onItemChanged: () => Promise<void> } & (
        | ISurveyTemplateUnitData
        | ISurveyTemplateElementGroupData
        | ISurveyTemplateManifestationData
    ),
) {
    switch (props.tabName) {
        case tabNames.rovLabelResult: {
            return <SurveyEditRovLabelResult {...props} />;
        }
        case tabNames.download:
        case tabNames.summaryAndAdvice:
            return null;
        default:
            return <h1>Unknown tab &quot;${props.tabName}&quot;</h1>;
    }
}
function SurveyDetailsLeftTrayListItems(props: { survey: ISurvey }) {
    const translate = useTranslate();
    return (
        <LeftTrayItem title={translate('rovLabel.label')}>
            <RovLabelScoreLabel conditionScore={props.survey.condition} />
        </LeftTrayItem>
    );
}
function SurveyDetailsScrollMenuItems(props: { scrollTo: (name: string) => void }) {
    return (
        <>
            <ScrollMenuItem text="Rov label" icon="fa fa-tag" onClick={() => props.scrollTo('RovLabel')} />
            <ScrollMenuItem text="Samenvatting en advies" icon="fa fa-file-text-o" onClick={() => props.scrollTo('SummaryAndAdvice')} />
        </>
    );
}
function SurveyDetailsComponents(props: { survey: Required<ISurvey> }) {
    return (
        <>
            <SurveyDetailsRovLabel surveyId={props.survey.id} />
        </>
    );
}
function SurveyEditSummaryAndAdvice(_props: { surveyId: string }): JSX.Element | null {
    return null;
}

function ConditionLabel(props: { conditionScore?: string }): JSX.Element | null {
    return <RovLabelScoreLabel conditionScore={props.conditionScore} />;
}

export const rovLabelFrontEndSettings: ICustomInspectionTypeFrontEndSettings = {
    tabNames,

    surveyEditTabs: [
        { name: tabNames.rovLabelResult, textTranslateKey: 'rovLabel.rovLabelResult' },
        { name: tabNames.download, textTranslateKey: 'survey.downloads' },
        { name: tabNames.summaryAndAdvice, textTranslateKey: 'survey.summaryAndAdviceTab' },
    ],

    surveyEditDefaultTabName: tabNames.rovLabelResult,
    showDocuments: true,

    objectTreeOptions: {
        hasElementsGroups: true,
        archiveLinkAvailable: false,
    },

    objectTreeDefaults: {
        filterOnElementGroups: true,
    },

    showObjectTree: (_tabName: string) => false,

    getSurveyConditionFilterOptions: () => {
        return labelSelectOptions.labelScore.map((i) => ({ value: rovLabelScoreToConditionScore(i.value as any), text: i.text }));
    },

    showLabelInSurveysMap: true,

    getSurveyEditPage: SurveyEditPage,
    getSurveyDetailsLeftTrayListItems: SurveyDetailsLeftTrayListItems,
    getSurveyDetailsScrollMenuItems: SurveyDetailsScrollMenuItems,
    getSurveyDetailsComponents: SurveyDetailsComponents,
    getSurveyEditSummaryAndAdvice: SurveyEditSummaryAndAdvice,
    getConditionLabel: ConditionLabel,
};
